/**
 * Categorical series colours for metric charts, in fixed slot order. Assign by the entity's
 * stable position (e.g. outlet number), never by rank, so a filter never repaints survivors.
 *
 * Validated (scripts/validate_palette.js from the dataviz method) against the app surfaces:
 * light #ffffff and dark #18181b both pass lightness band, chroma, adjacent CVD separation
 * (worst dE 9.1 light / 8.4 dark) and the normal-vision floor. Three light slots are below 3:1
 * contrast, so charts using this palette must offer a table view - MetricChartComponent does.
 */
export const METRIC_SERIES_LIGHT = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'] as const;
export const METRIC_SERIES_DARK = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'] as const;

/** Colour for series beyond the eighth, which are folded into a single "Other" series. */
export const METRIC_OTHER_LIGHT = '#8a8983';
export const METRIC_OTHER_DARK = '#8a8983';

export const METRIC_MAX_SERIES = METRIC_SERIES_LIGHT.length;

export function metricSeriesColor(slot: number, dark: boolean): string {
    const palette = dark ? METRIC_SERIES_DARK : METRIC_SERIES_LIGHT;
    return slot < palette.length ? palette[slot] : dark ? METRIC_OTHER_DARK : METRIC_OTHER_LIGHT;
}

/** Hex colour with alpha, for area fills. */
export function withAlpha(hex: string, alpha: number): string {
    const value = parseInt(hex.slice(1), 16);
    return `rgba(${(value >> 16) & 255}, ${(value >> 8) & 255}, ${value & 255}, ${alpha})`;
}
